
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.69 33.84V7.18c0-3.67-1.9-5.68-5.42-5.68H7.73c-3.52 0-5.42 2-5.42 5.68v26.66zM2.61 7.45h34.78M2.47 21.06h35.06M20 8.12v13.64","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"9.38","cy":"27.47","r":"2.45","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"30.62","cy":"27.47","r":"2.45","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M10.32 34.58v3.92H5.3v-3.92M34.7 34.58v3.92h-5.02v-3.92"}})])
          )
        }
      }
    